<template>
    <b-modal
        id="results-modal"
        v-model="modal"
        :ok-title="$t('common.close')"
        size="lg"
        ok-only
        modal-class="apprentice-default-modal"
        dusk="issue-test-modal">
        <template #modal-header="{ close }">
            <h5 class="modal-title">
                {{ $t('testcenter.result_of_student', { name: testResponse.user.full_name }) }}
                <small>{{
                    $t('testcenter.submitted_on_date', { date: formattedDate(testResponse.updated_at) })
                }}</small>
            </h5>
            <b-button
                class="close btn-times"
                variant="primary-icon-only"
                @click="close()">
            </b-button>
        </template>

        <div
            class="test-results"
            v-if="testResponse">
            <design-2021-show-test-result-component :test-response-in="testResponse">
            </design-2021-show-test-result-component>
        </div>
    </b-modal>
</template>

<script>
import Design2021StudyChoiceTestComponent20240516 from '../response/result/design-2021-job-personality-study-choice-test-2024-05-16-component.vue';

export default {
    name: 'design-2021-test-center-results-modal-component',
    components: { Design2021StudyChoiceTestComponent20240516 },
    props: {
        testIssuingIn: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            modal: false,
            testResponse: null,
        };
    },
    methods: {
        show(testResponse) {
            this.testResponse = testResponse;
            if (!testResponse?.test_issuing) {
                this.testResponse.test_issuing = this.testIssuingIn;
            }

            this.modal = true;
        },

        formattedDate(date) {
            return new Date(date)
                .toLocaleString('nl-NL', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                })
                .replace(/-/g, '-')
                .replace(/\//g, '-')
                .replace(',', '');
        },
    },
};
</script>

<style scoped lang="scss">
.modal-title {
    display: flex;
    flex-direction: column;
    row-gap: map-get($grid-gutter-spacing, 'four');
    line-height: 1;

    small {
        font-size: 0.75rem;
    }
}
</style>
